import { render, staticRenderFns } from "./LevelCategoryList.vue?vue&type=template&id=1dec1e7a&scoped=true"
import script from "./LevelCategoryList.vue?vue&type=script&lang=js"
export * from "./LevelCategoryList.vue?vue&type=script&lang=js"
import style0 from "./LevelCategoryList.vue?vue&type=style&index=0&id=1dec1e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec1e7a",
  null
  
)

export default component.exports